import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { VersionService, AppVersions } from '@/services/version.service';

@Component({
  selector: 'app-version-info',
  standalone: true,
  imports: [
    CommonModule,
    DialogModule,
    ButtonModule,
    ProgressSpinnerModule,
    ToastModule,
  ],
  providers: [MessageService],
  templateUrl: './version-info.component.html',
  styleUrls: ['./version-info.component.scss']
})
export class VersionInfoComponent implements OnInit {
  visible = false;
  versions: AppVersions | null = null;
  loading = false;

  constructor(
    private versionService: VersionService,
    private messageService: MessageService
  ) {}

  ngOnInit() {}

  show() {
    this.visible = true;
    this.loadVersions();
  }

  private loadVersions() {
    this.loading = true;
    this.versionService.getAllVersions().subscribe({
      next: (versions) => {
        this.versions = versions;
        this.loading = false;
      },
      error: (error) => {
        console.error('Failed to load versions', error);
        this.loading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to load version information'
        });
      }
    });
  }

  formatUptime(seconds?: number): string {
    if (!seconds) return 'N/A';
    const days = Math.floor(seconds / 86400);
    const hours = Math.floor((seconds % 86400) / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    return `${days}d ${hours}h ${minutes}m`;
  }

  formatDate(dateString?: string): string {
    if (!dateString) return 'N/A';
    try {
      const date = new Date(dateString);
      return date.toLocaleString();
    } catch {
      return dateString;
    }
  }

  copyVersionInfo() {
    if (!this.versions) return;

    const text = `
Envolve System Information
--------------------------
UI Version: ${this.versions.ui.version}
UI Build ID: ${this.versions.ui.buildId}

API Version: ${this.versions.api.version}
API Build ID: ${this.versions.api.buildId}
    `.trim();

    navigator.clipboard.writeText(text).then(() => {
      this.messageService.add({
        severity: 'success',
        summary: 'Copied',
        detail: 'Version information copied to clipboard'
      });
    }).catch(err => {
      console.error('Failed to copy', err);
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to copy to clipboard'
      });
    });
  }
}
